import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { projectsApi } from "./features/projects/apiSlice";
import { dashboardApi } from "./features/dashboard/apiSlice";
import { managementDashboardApi } from "./features/management-dashboard/apiSlice";
import { activitiesApi } from "./features/activities/apiSlice";
import { devicesApi } from "./features/devices/apiSlice";
import { deviceLogsApi } from "./features/device-logs/apiSlice";
import { alertProfilesApi } from "./features/alert-profiles/apiSlice";
import { distortionPairsApi } from "./features/distortion-pairs/apiSlice";
import { reportsApi } from "./features/reports/apiSlice";

export const store = configureStore({
  reducer: {
    [projectsApi.reducerPath]: projectsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [managementDashboardApi.reducerPath]: managementDashboardApi.reducer,
    [activitiesApi.reducerPath]: activitiesApi.reducer,
    [devicesApi.reducerPath]: devicesApi.reducer,
    [deviceLogsApi.reducerPath]: deviceLogsApi.reducer,
    [alertProfilesApi.reducerPath]: alertProfilesApi.reducer,
    [distortionPairsApi.reducerPath]: distortionPairsApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      projectsApi.middleware,
      dashboardApi.middleware,
      managementDashboardApi.middleware,
      activitiesApi.middleware,
      devicesApi.middleware,
      deviceLogsApi.middleware,
      alertProfilesApi.middleware,
      distortionPairsApi.middleware,
      reportsApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
